/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FixedWingLineResponse } from '../../models/fixed-wing-line-response';
import { UpdateFixedWingLineRequest } from '../../models/update-fixed-wing-line-request';

export interface UpdateFixedWingLine$Params {
  id: number;
      body: UpdateFixedWingLineRequest
}

export function updateFixedWingLine(http: HttpClient, rootUrl: string, params: UpdateFixedWingLine$Params, context?: HttpContext): Observable<StrictHttpResponse<FixedWingLineResponse>> {
  const rb = new RequestBuilder(rootUrl, updateFixedWingLine.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FixedWingLineResponse>;
    })
  );
}

updateFixedWingLine.PATH = '/api/scheduler/daily-line-schedule/fixed-wing/lines/{id}';
